export default __webpack_public_path__ + "static/media/DSCN1687.0a1caa1e.JPG";